// extracted by mini-css-extract-plugin
module.exports = {"imgLogo":"Footer_imgLogo__1n5OQ","footer":"Footer_footer__381x8","footerLink":"Footer_footerLink__3s1dc","active":"Footer_active__3LV2P","topSpace":"Footer_topSpace__36FC7"};